import styled from "styled-components";
import { Box } from "@mui/material";

export const SocialMediaWrapper = styled(Box)`
	display: flex;
	flex-direction: column;
	padding: 10px;

	.MuiFormControlLabel-label {
		font-size: 14px;
	}
	.MuiInputBase-input {
		height: 12px;
	}
	${props => props.theme.breakpoints.down("sm")} {
		.MuiFormControlLabel-label {
			font-size: 12px;
		}
	}
`;
